const BUILDER_POSTMASTER = 'postmaster@builder.msging.net';
export class FunctionService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async getAllFunctions() {
        const response = await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: '/functions',
            to: BUILDER_POSTMASTER,
        });
        return response.items || [];
    }
    async getFunctionsWithQueryParams(functionName) {
        const uri = `/functions?functionName=${functionName}`;
        const response = await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: uri,
            to: BUILDER_POSTMASTER,
        });
        return response.items || [];
    }
    async getFunctionsWithSkipTake(skip, take) {
        const uri = `/functions?skip=${skip}&take=${take}`;
        const response = await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: uri,
            to: BUILDER_POSTMASTER,
        });
        return response.items || [];
    }
    async setFunctionWithApplication(resource, type = 'application/vnd.iris.builder.application.functions+json') {
        return await this.MessagingHubService.sendCommand({
            to: BUILDER_POSTMASTER,
            type: type,
            method: 'set',
            uri: '/application/function',
            resource: resource,
        });
    }
    async setFunction(resource) {
        return await this.MessagingHubService.sendCommand({
            to: BUILDER_POSTMASTER,
            type: 'application/vnd.lime.document+json',
            method: 'set',
            uri: '/functions/',
            resource: resource,
        });
    }
    async updateFunction(functionId, resource) {
        return await this.MessagingHubService.sendCommand({
            to: BUILDER_POSTMASTER,
            type: 'application/vnd.lime.document+json',
            method: 'set',
            uri: `/functions/${functionId}`,
            resource: resource,
        });
    }
    async deleteFunction(functionId) {
        return await this.MessagingHubService.sendCommand({
            to: BUILDER_POSTMASTER,
            method: 'delete',
            uri: `/functions/${functionId}`,
        });
    }
    async deleteFunctionWithApplication(applicationIdentity, functionId) {
        return await this.MessagingHubService.sendCommand({
            to: BUILDER_POSTMASTER,
            method: 'delete',
            uri: `/applications/${applicationIdentity}/function/${functionId}`,
        });
    }
    async getApplicationsOfAFunction(functionId) {
        const response = await this.MessagingHubService.sendCommand({
            to: BUILDER_POSTMASTER,
            method: 'get',
            uri: `/applications/function/${functionId}`,
        });
        return response.items || [];
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
FunctionService.$inject = ['MessagingHubService'];
